import Header from "./components/Header";
import Sidebar from "./components/Sidebar";
import Slide from "./components/Slide";

import SearchBar from "./components/SearchBar";
import Suggestions from "./components/Suggestions";
import BooksSlide from "./components/BooksSlide";

import { useState, useEffect } from "react";
import { libri } from "./data/libri";

export default function App() {

  const [query, setQuery] = useState("");
  const [suggerimenti, setSuggerimenti] = useState([]);
  const [autoreSelezionato, setAutoreSelezionato] = useState(null);

  // 🔹 Genera suggerimenti mentre scrivi
  useEffect(() => {
    if (query.length > 0) {
      const match = libri
        .map((l) => l.autore)
        .filter((a) => a.toLowerCase().includes(query.toLowerCase()));

      const unici = [...new Set(match)];
      setSuggerimenti(unici.slice(0, 5));
    } else {
      setSuggerimenti([]);
      setAutoreSelezionato(null);
    }
  }, [query]);

  // 🔹 Libri dell'autore selezionato
  const libriAutore = autoreSelezionato
    ? libri.filter((l) => l.autore === autoreSelezionato)
    : [];

  // 🔹 Quando clicchi un autore
  const handleSelectAutore = (autore) => {
    setQuery(autore);
    setAutoreSelezionato(autore);
    setSuggerimenti([]); // chiude suggerimenti
  };

  // 🔹 Chiude i suggerimenti con la X
  const closeSuggerimenti = () => {
    setSuggerimenti([]);
  };
const closeBooks = () => {
  setAutoreSelezionato(null);
};

return (
  <>
    <Header />

    <Sidebar />

    <div
      className="search-wrapper"
      style={{
        position: "absolute",
        top: "120px",            // distanza dall’header
        left: "50%",
        transform: "translateX(-50%)",

        width: "90%",
        maxWidth: "620px",

        padding: "22px 26px",
        background: "rgba(255, 255, 255, 0.45)",
        backdropFilter: "blur(12px)",
        WebkitBackdropFilter: "blur(12px)",
        borderRadius: "16px",
        boxShadow: "0 8px 28px rgba(0,0,0,0.10)",
        transition: "all 0.35s ease",
        zIndex: 0,
        boxSizing: "border-box",
      }}
    >
      <SearchBar query={query} setQuery={setQuery} />

      <Suggestions
        suggerimenti={suggerimenti}
        onSelect={handleSelectAutore}
        onClose={closeSuggerimenti}
      />

      <BooksSlide
        autore={autoreSelezionato}
        libri={libriAutore}
        onClose={closeBooks}
      />
    </div>
 
);



      {/* 🔹 CONTENUTO DELLA PAGINA */}
      <div style={{ paddingTop: "230px", paddingLeft: "50px", paddingRight: "20px" }}>
        <h1>Archivio Libri</h1>
      




















        <Slide
          title="Romanzi"
          items={[
                { img: "/Romanzi/All your perfects.png", title: "All your perfects", subtitle: "1" },
    { img: "/Romanzi/Anna Premoli E solo una storia d'amore.png", title: "Anna Premoli E solo una storia d'amore", subtitle: "" },
{ img: "/Romanzi/Better.png", title: "Better", subtitle: "" },

{ img: "/Romanzi/Due cuori in affitto.png", title: "Due cuori in affitto", subtitle: "" },

{ img: "/Romanzi/Fabbricante di lacrime.png", title: "Fabbricante di lacrime", subtitle: "" },

{ img: "/Romanzi/Fidanzato part-time.png", title: "Fidanzato part-time", subtitle: "" },
{ img: "/Romanzi/Il mio indimenticabile amore francese.png", title: "Il mio indimenticabile amore francese", subtitle: "" },
{ img: "/Romanzi/It Ends With us.png", title: "It Ends With us", subtitle: "" },
{ img: "/Romanzi/It Starts With us.png", title: "It Starts With us", subtitle: "" },
{ img: "/Romanzi/La verita è che non ti odio abbastanza.png", title: "La verita è che non ti odio abbastanza", subtitle: "" },
{ img: "/Romanzi/Liberi come la neve.png", title: "Liberi come la neve", subtitle: "" },
{ img: "/Romanzi/Nel mondo in cui cade la neve.png", title: "Nel mondo in cui cade la neve", subtitle: "" },
{ img: "/Romanzi/Prima regola non innamorarsi.png", title: "Prima regola non innamorarsi", subtitle: "" },

{ img: "/Romanzi 2/I segreti di una libraia..png", title: "I segreti di una libraia.", subtitle: "" },
{ img: "/Romanzi 2/Il cacciatore di aquiloni.png", title: "Il cacciatore di aquiloni", subtitle: "" },
{ img: "/Romanzi 2/Il manosritto perduto della massonoeria.png", title: "Il manosritto perduto della massonoeria", subtitle: "" },
{ img: "/Romanzi 2/Il profondo segreto del mare.png", title: "Il profondo segreto del mare", subtitle: "" },
{ img: "/Romanzi 2/Il sentiero degli alberi di limone.png", title: "Il sentiero degli alberi di limone", subtitle: "" },
{ img: "/Romanzi 2/Isegreti della famiglia cartwright.png", title: "Isegreti della famiglia cartwright", subtitle: "" },
{ img: "/Romanzi 2/La bambina che guardava i treni partire.png", title: "La bambina che guardava i treni partire", subtitle: "" },
{ img: "/Romanzi 2/Mille splendidi soli.png", title: "Mille splendidi soli", subtitle: "" },
{ img: "/Romanzi 2/Mister money.png", title: "Mister money", subtitle: "" },
{ img: "/Romanzi 2/Piccole donne.png", title: "Piccole donne", subtitle: "" },
{ img: "/Romanzi 2/Ramses.png", title: "Ramses", subtitle: "" },
{ img: "/Romanzi 2/Sia fatta la tua volontà.png", title: "Sia fatta la tua volontà", subtitle: "" },
{ img: "/Romanzi 2/Storia proibita di una geisha.png", title: "Storia proibita di una geisha", subtitle: "" },
{ img: "/Romanzi 2/Storia del nuovo cognome.png", title: "Storia del nuovo cognome", subtitle: "" },
{ img: "/Romanzi 2/Storia di una bambina perduta.png", title: "Storia di una bambina perduta", subtitle: "" },
{ img: "/Romanzi 2/Storie di chi fugge e di chi resta.png", title: "Storie di chi fugge e di chi resta", subtitle: "" },

{ img: "/Romanzi 2/L'amica Geniale.png", title: "L'amica Geniale", subtitle: "" },

{ img: "/Romanzi 2/I Segreti delle spose indiane.png", title: "I Segreti delle spose indiane", subtitle: "" },

{ img: "/Romanzi 2/Insciaqqua.png", title: "Insciaqqua", subtitle: "" },

{ img: "/Romanzi 2/Mi scaglio la prima pietra.png", title: "Mi scaglio la prima pietra", subtitle: "" },

{ img: "/Romanzi 2/Scusatemi ho il patè d'animo.png", title: "Scusatemi ho il patè d'animo", subtitle: "" },


{ img: "/Romanzi 2/Fiaba perversa.png", title: "Fiaba perversa", subtitle: "" },

{ img: "/Romanzi 2/Independence day.png", title: "Independence day", subtitle: "" },

{ img: "/Romanzi 2/Paura dei cinquanta.png", title: "Paura dei cinquanta", subtitle: "" },

{ img: "/Romanzi 2/Caccia all'uomo.png", title: "Caccia all'uomo", subtitle: "" },

{ img: "/Romanzi 2/A che punto è la notte.png", title: "A che punto è la notte", subtitle: "" },

{ img: "/Romanzi 2/Il sangue dei vinti.png", title: "Il sangue dei vinti", subtitle: "" },
{ img: "/Romanzi 2/Delitti senza castigo.png", title: "Delitti senza castigo", subtitle: "" },

{ img: "/Romanzi 2/Ombre in paradiso.png", title: "Ombre in paradiso", subtitle: "" },

{ img: "/Romanzi 2/Il silenzio degli innocenti.png", title: "Il silenzio degli innocenti", subtitle: "" },
{ img: "/Romanzi 2/La Donna Delle Meraviglie.png", title: "La Donna Delle Meraviglie", subtitle: "" },

{ img: "/Romanzi 2/La mosca al naso.png", title: "La mosca al naso", subtitle: "" },

{ img: "/Romanzi 2/Senza dire arrivederci.png", title: "Senza dire arrivederci", subtitle: "" },

{ img: "/Romanzi 2/Il socio.png", title: "Il socio", subtitle: "" },

{ img: "/Romanzi 2/Un piano semplice.png", title: "Un piano semplice", subtitle: "" },


{ img: "/Romanzi 2/Scusate dimenticavo.png", title: "Scusate dimenticavo", subtitle: "" },


{ img: "/Romanzi 2/La passione di Joe Crown.png", title: "La passione di Joe Crown", subtitle: "" },


{ img: "/Romanzi 2/L'amante di Pilato.png", title: "L'amante di Pilato", subtitle: "" },

{ img: "/Romanzi 2/Fatherland.png", title: "Fatherland", subtitle: "" },

{ img: "/Romanzi 2/Addio Volodia.png", title: "Addio Volodia", subtitle: "" },

{ img: "/Romanzi 2/Io uccido.png", title: "Io uccido", subtitle: "" },


{ img: "/Romanzi 2/Il trono vuoto.png", title: "Il trono vuoto", subtitle: "" },

{ img: "/Romanzi 2/Mille camere.png", title: "Mille camere", subtitle: "" },

{ img: "/Romanzi 2/Paura di volare.png", title: "Paura di volare", subtitle: "" },


{ img: "/Romanzi 2/L'ultimo Catone.png", title: "L'ultimo Catone", subtitle: "" },

{ img: "/Romanzi 2/Una lunga marcia.png", title: "Una lunga marcia", subtitle: "" },



          ]}
        />

 <Slide
          title="Gialli"
          items={[
               { img: "/Gialli/Chi nulla rischia.png", title: "Chi nulla rischia", subtitle: "" },
    { img: "/Gialli/Il giallo del paese maledetto.png", title: "Il giallo del paese maledetto", subtitle: "" },
{ img: "/Gialli/Il gioco del male.png", title: "Il gioco del male", subtitle: "" },

{ img: "/Gialli/La Confraternita degli Assassini.png", title: "La Confraternita degli Assassini", subtitle: "" },

{ img: "/Gialli/L'abbazia dei cento delitti.png", title: "L'abbazia dei cento delitti", subtitle: "" },

{ img: "/Gialli/L'imbalsamatore.png", title: "L'imbalsamatore", subtitle: "" },
{ img: "/Gialli/L'uomo senza sonno.png", title: "L'uomo senza sonno", subtitle: "" },
{ img: "/Gialli/Maledetta primavera.png", title: "Maledetta primavera", subtitle: "" },
{ img: "/Gialli/Per la gloria di roma.png", title: "Per la gloria di roma", subtitle: "" },
{ img: "/Gialli/Per questo mi chiamo Giovanni.png", title: "Per questo mi chiamo Giovanni", subtitle: "" },
{ img: "/Gialli/Tre cadaveri.png", title: "Tre cadaveri", subtitle: "" },
{ img: "/Gialli/Verita e bugie.png", title: "Verita e bugie", subtitle: "" },
{ img: "/Gialli 2/Blackout.png", title: "Blackout", subtitle: "" },
{ img: "/Gialli 2/Cattivi amici.png", title: "Cattivi amici", subtitle: "" },
{ img: "/Gialli 2/GL Barone.png", title: "GL Barone", subtitle: "" },
{ img: "/Gialli 2/Il manoscritto perduto della massoneria.png", title: "Il manoscritto perduto della massoneria", subtitle: "" },
{ img: "/Gialli 2/Il Broker.png", title: "Il Broker", subtitle: "" },

{ img: "/Gialli 2/Io e Saddam.png", title: "Io e Saddam", subtitle: "" },






          ]}
        />


<Slide
          title="Letteratura"
          items={[
               { img: "/Letteratura/Adriano VII.png", title: "Adriano VII", subtitle: "" },
    { img: "/Letteratura/Anestesia.png", title: "Anestesia", subtitle: "" },
{ img: "/Letteratura/Cuero tango y pasion.png", title: "Cuero tango y pasion", subtitle: "" },

{ img: "/Letteratura/E tutto una bugia.png", title: "E tutto una bugia", subtitle: "" },

{ img: "/Letteratura/Gabonzo.png", title: "Gabonzo", subtitle: "" },

{ img: "/Letteratura/Il Ladro di quaderni.png", title: "Il Ladro di quaderni", subtitle: "" },
{ img: "/Letteratura/Il tamburo di latta.png", title: "Il tamburo di latta", subtitle: "" },
{ img: "/Letteratura/Il treno dei bambini.png", title: "Il treno dei bambini", subtitle: "" },
{ img: "/Letteratura/La farsa gattopardesca degli scatoloni.png", title: "La farsa gattopardesca degli scatoloni", subtitle: "" },
{ img: "/Letteratura/La fattoria dell'animale.png", title: "La fattoria dell'animale", subtitle: "" },
{ img: "/Letteratura/La quarta guerra mondiale.png", title: "La quarta guerra mondiale", subtitle: "" },
{ img: "/Letteratura/Le nostre imperfezioni.png", title: "Le nostre imperfezioni", subtitle: "" },

{ img: "/Letteratura/L'ora X.png", title: "L'ora X", subtitle: "" },
{ img: "/Letteratura/Quaderno del palazzo reale.png", title: "Quaderno del palazzo reale", subtitle: "" },
{ img: "/Letteratura/Tante storie per giocare.png", title: "Tante storie per giocare", subtitle: "" },

 { img: "/Letteratura 2/Abbassa il calcio viva il pallone.png", title: "Abbassa il calcio viva il pallone", subtitle: "" },
    { img: "/Letteratura 2/Alba.png", title: "Alba", subtitle: "" },
{ img: "/Letteratura 2/Cime tempestose.png", title: "Cime tempestose", subtitle: "" },

{ img: "/Letteratura 2/I dolori del giovane Werther.png", title: "I dolori del giovane Werther", subtitle: "" },

{ img: "/Letteratura 2/I pesci non chiudono gli occhi.png", title: "I pesci non chiudono gli occhi", subtitle: "" },

{ img: "/Letteratura 2/Il maestro e margherita.png", title: "Il maestro e margherita", subtitle: "" },
{ img: "/Letteratura 2/Il passaporto strappato.png", title: "Il passaporto strappato", subtitle: "" },
{ img: "/Letteratura 2/Il rancore di Yukiko.png", title: "Il rancore di Yukiko", subtitle: "" },
{ img: "/Letteratura 2/La vitienologia in campania.png", title: "La vitienologia in campania", subtitle: "" },
{ img: "/Letteratura 2/Marcovaldo.png", title: "Marcovaldo", subtitle: "" },
{ img: "/Letteratura 2/Noche porteria.png", title: "Noche porteria", subtitle: "" },
{ img: "/Letteratura 2/Non avevo capito ninete.png", title: "Non avevo capito ninete", subtitle: "" },

{ img: "/Letteratura 2/Oliver Twist.png", title: "Oliver Twist", subtitle: "" },
{ img: "/Letteratura 2/Orgoglio e pregiudizzo.png", title: "Orgoglio e pregiudizzo", subtitle: "" },




{ img: "/Letteratura 2/Per come ti guardo ti ho già detto troppo.png", title: "Per come ti guardo ti ho già detto troppo", subtitle: "" },
{ img: "/Letteratura 2/Scusa ma tifo Napoli.png", title: "Scusa ma tifo Napoli", subtitle: "" },
{ img: "/Letteratura 2/Storie di calcio femminile.png", title: "Storie di calcio femminile", subtitle: "" },

{ img: "/Letteratura 2/Ti dimentico ma non ti cancello.png", title: "Ti dimentico ma non ti cancello", subtitle: "" },
{ img: "/Letteratura 2/Il Dubbio.png", title: "Il Dubbio", subtitle: "" },

{ img: "/Letteratura 2/La Famiglia Moskat.png", title: "La Famiglia Moskat", subtitle: "" },


{ img: "/Letteratura 2/Sembra Ieri.png", title: "Sembra Ieri", subtitle: "" },
{ img: "/Letteratura 2/Elena Elena Amore Mio.png", title: "Elena Elena Amore Mio", subtitle: "" },

{ img: "/Letteratura 2/Storia Della Filosofia Graca.png", title: "Storia Della Filosofia Graca", subtitle: "" },

{ img: "/Letteratura 2/I Borgia.png", title: "I Borgia", subtitle: "" },

{ img: "/Letteratura 2/Zio Cardellino.png", title: "Zio Cardellino", subtitle: "" },

{ img: "/Letteratura 2/Il Tempo E La Felicità.png", title: "Il Tempo E La Felicità", subtitle: "" },

{ img: "/Letteratura 2/Introduzione alla sociaologia generale.png", title: "Introduzione alla sociaologia generale", subtitle: "" },
{ img: "/Letteratura 2/Onassis.png", title: "Onassis", subtitle: "" },

{ img: "/Letteratura 2/Il Discepolo.png", title: "Il Discepolo", subtitle: "" },

{ img: "/Letteratura 2/Caso di onosessualità in una donna.png", title: "Caso di onosessualità in una donna", subtitle: "" },

{ img: "/Letteratura 2/La crisi della sociologia.png", title: "La crisi della sociologia", subtitle: "" },



          ]}
        />




<Slide
          title="Storia"// Questi sono storia  ma per modifiche hanno nomi delle cartelle di classsici
          items={[
               { img: "/Classici/Napoleone 1 La voce del destino.png", title: "Napoleone 1 La voce del destino", subtitle: "" },
    { img: "/Classici/Napoleone 2 I Cieli dell'impero.png", title: "Napoleone 2 I Cieli dell'impero", subtitle: "" },
{ img: "/Classici/Il Congresso di vienna.png", title: "Il Congresso di vienna", subtitle: "" },

{ img: "/Classici/Alessandro 1 Lo zar della santa alleanza.png", title: "Alessandro 1 Lo zar della santa alleanza", subtitle: "" },

{ img: "/Classici/Metternich.png", title: "Metternich", subtitle: "" },

{ img: "/Classici/Il Risorgimento italiano.png", title: "Il Risorgimento italiano", subtitle: "" },
{ img: "/Classici/Il Re Che Tentoò Di Fare L'Italia.png", title: "Il Re Che Tentoò Di Fare L'Italia", subtitle: "" },
{ img: "/Classici/Balaclava La Carica dei 600.png", title: "Balaclava La Carica dei 600", subtitle: "" },
{ img: "/Classici/Mazzini L'Uomo ,Il Pensatore, Il Rivoluzionario.png", title: "Mazzini L'Uomo ,Il Pensatore, Il Rivoluzionario", subtitle: "" },
{ img: "/Classici/Risorgimento e Capitaliasmo.png", title: "Risorgimento e Capitaliasmo", subtitle: "" },
    { img: "/Classici/Garibaldi.png", title: "Garibaldi", subtitle: "" },
    { img: "/Classici/Italiane Il Lato Segreto Del Risorgimento.png", title: "Italiane Il Lato Segreto Del Risorgimento.", subtitle: "" },
{ img: "/Classici/Il Re Bomba.png", title: "Il Re Bomba", subtitle: "" },

{ img: "/Classici/Vittorio Emanuele 2.png", title: "Vittorio Emanuele 2", subtitle: "" },

{ img: "/Classici/Francesco II di Borbone.png", title: "Francesco II di Borbone", subtitle: "" },

{ img: "/Classici/Storia Militare Del Risorgimento 1.png", title: "Storia Militare Del Risorgimento 1", subtitle: "" },
{ img: "/Classici/Storia Militare Del Risorgimento 2.png", title: "Storia Militare Del Risorgimento 2", subtitle: "" },
{ img: "/Classici/Gli Uomini Che Fecero L'italia.png", title: "Gli Uomini Che Fecero L'italia", subtitle: "" },
{ img: "/Classici/Pio IX.png", title: "Pio IX", subtitle: "" },
{ img: "/Classici/Cavour Il Grande Tessitore Dell'Unità D'Italia.png", title: "Cavour Il Grande Tessitore Dell'Unità D'Italia", subtitle: "" },


{ img: "/Classici/La Guerra Civile Americana.png", title: "La Guerra Civile Americana", subtitle: "" },
{ img: "/Classici/Lungo Le Rive Del Colorado.png", title: "Lungo Le Rive Del Colorado", subtitle: "" },
{ img: "/Classici/Storia DEgli Indiani D'America.png", title: "Storia DEgli Indiani D'America", subtitle: "" },

{ img: "/Classici/La piccola Regina.png", title: "La piccola Regina", subtitle: "" },
{ img: "/Classici/Marx.png", title: "Marx", subtitle: "" },
{ img: "/Classici/Ludwig.png", title: "Ludwig", subtitle: "" },

{ img: "/Classici/Storia Economica D'Italia.png", title: "Storia Economica D'Italia", subtitle: "" },

{ img: "/Classici/Gli Emigrati Vittoriosi.png", title: "Gli Emigrati Vittoriosi", subtitle: "" },

{ img: "/Classici/Lindustrializzazione in europa nellì 800.png", title: "Lindustrializzazione in europa nellì 800", subtitle: "" },

{ img: "/Classici/Francesco Giuseppe Il Lungo Crepuscolo degli Assurgo.png", title: "Francesco Giuseppe Il Lungo Crepuscolo degli Assurgo", subtitle: "" },


{ img: "/Classici/Requiem per un impero defunto.png", title: "Requiem per un impero defunto", subtitle: "" },
{ img: "/Storia 2/Il Sgnor Fiat.png", title: "Il Sgnor Fiat", subtitle: "" },

{ img: "/Classici//Rasputin.png", title: "Rasputin", subtitle: "" },

{ img: "/Classici/La spartizione DEll'africa.png", title: "La spartizione DEll'africa", subtitle: "" },


{ img: "/Classici/Crispi.png", title: "Crispi", subtitle: "" },


{ img: "/Classici/L'anarchico che venne Dalla'Amarica.png", title: "L'anarchico che venne Dalla'Amarica", subtitle: "" },

{ img: "/Classici/La regina Margherita.png", title: "La regina Margherita", subtitle: "" },


{ img: "/Classici/Storia D'Italia Moderna 1815-1898.png", title: "Storia D'Italia Moderna 1815-1898", subtitle: "" },




{ img: "/Classici/Storia D'italia Moderna 1898-1910.png", title: "Storia D'italia Moderna 1898-1910", subtitle: "" },
{ img: "/Classici/Lorenzo il magnifico  1.png", title: "Lorenzo il magnifico  1", subtitle: "" },


{ img: "/Classici/Lorenzo il magnifico  2.png", title: "Lorenzo il magnifico  2", subtitle: "" },


{ img: "/Classici/Le repubbliche marinare.png", title: "Le repubbliche marinare", subtitle: "" },


{ img: "/Classici/Cristoforo Colombo.png", title: "Cristoforo Colombo", subtitle: "" },


]}
        />






 <Slide
          title="Classici"// Questi sono classici ma per modifiche hanno nomi delle cartelle di storia
          items={[
 
{ img: "/Storia/Ricordi volume I.png", title: "Ricordi volume I", subtitle: "" }, 

 { img: "/Storia/Ricordi volume II.png", title: "Ricordi volume II", subtitle: "" }, 

  { img: "/Storia/Le Metamorfosi o L'asino d'oro.png", title: "Le Metamorfosi o L'asino d'oro", subtitle: "" },  

  { img: "/Storia/Dell'oratore volume II.png", title: "Dell'oratore volume II", subtitle: "" },  

  { img: "/Storia/Anabasi.png", title: "Anabasi", subtitle: "" },  

   { img: "/Storia/Dialoghi La vecchiezza - L'amicizia.png", title: "Dialoghi La vecchiezza - L'amicizia", subtitle: "" },   

   { img: "/Storia/Orestea.png", title: "Orestea", subtitle: "" },         

{ img: "/Storia/I Canti.png", title: "I Canti", subtitle: "" },

{ img: "/Storia/La repubblica volume I.png", title: "La repubblica volume I", subtitle: "" },

{ img: "/Storia/La vita di Agricola La Germania.png", title: "La vita di Agricola La Germania", subtitle: "" },

{ img: "/Storia/Dell'oratore volume I.png", title: "Dell'oratore volume I", subtitle: "" },

{ img: "/Storia/Poesie.png", title: "Poesie", subtitle: "" },


{ img: "/Storia/Lisistrata Le donne al parlamento.png", title: "Lisistrata Le donne al parlamento", subtitle: "" },

{ img: "/Storia/La Guerra di Giugurta.png", title: "La Guerra di Giugurta", subtitle: "" },

{ img: "/Storia/La natura delle cose volume II.png", title: "La natura delle cose volume II", subtitle: "" },


{ img: "/Storia/Antigone Edipo re Edipo a Colono.png", title: "Antigone Edipo re Edipo a Colono", subtitle: "" },

{ img: "/Storia/La natura delle cose volume I.png", title: "La natura delle cose volume I", subtitle: "" },

{ img: "/Storia/Satyricon.png", title: "Satyricon", subtitle: "" },
{ img: "/Storia/Medea.png", title: "Medea", subtitle: "" },

{ img: "/Storia/Le opere e i giorni Lo scudo di Eracle.png", title: "Le opere e i giorni Lo scudo di Eracle", subtitle: "" },

{ img: "/Storia/Simposio.png", title: "Simposio", subtitle: "" },

{ img: "/Storia/Catilinarie.png", title: "Catilinarie", subtitle: "" },

{ img: "/Storia/La pentola del tesoro.png", title: "La pentola del tesoro", subtitle: "" },

{ img: "/Storia/Poetica.png", title: "Poetica", subtitle: "" },


{ img: "/Storia/Lettere 2.png", title: "Lettere 2", subtitle: "" },

{ img: "/Storia/Vite Parallele Alessandro e Cesare.png", title: "Vite Parallele Alessandro e Cesare", subtitle: "" },


{ img: "/Storia/Epigrammi.png", title: "Epigrammi", subtitle: "" },
{ img: "/Storia/Bucoliche.png", title: "Bucoliche", subtitle: "" },

 { img: "/Storia/Apologia di Socreate Critone.png", title: "Apologia di Socreate Critone", subtitle: "" },

 { img: "/Storia/L'arte d'amare.png", title: "L'arte d'amare", subtitle: "" },


 { img: "/Storia/Satire.png", title: "Satire", subtitle: "" },

           { img: "/Storia/Dialoghi.png", title: "Dialoghi", subtitle: "" },
           
           { img: "/Storia/Lettere.png", title: "Lettere", subtitle: "" },
           
            { img: "/Storia/La repubblica volume II.png", title: "La repubblica volume II", subtitle: "" },
           
            { img: "/Storia/Baccanti.png", title: "Baccanti", subtitle: "" }, 
            { img: "/Storia/Le Metamorfosi o L'asino d'or volumeII.png", title: "Le Metamorfosi o L'asino d'or volumeII", subtitle: "" }, 
           
           
            { img: "/Storia/Elegie.png", title: "Elegie", subtitle: "" },    
        { img: "/Storia/Favole.png", title: "Favole", subtitle: "" },    
           
       { img: "/Storia/La guerra civile.png", title: "La guerra civile", subtitle: "" },       
    { img: "/Storia/Storie Volume IV.png", title: "Storie Volume IV", subtitle: "" },        
           
     { img: "/Storia/I Menecmi.png", title: "I Menecmi ", subtitle: "" },          
    { img: "/Storia/Eneide volume2 .png", title: "Eneide volume2 ", subtitle: "" },        
           
            { img: "/Storia/I promessi sposi.png", title: "I promessi sposi", subtitle: "" },
    { img: "/Storia/Il piacere.png", title: "Il piacere", subtitle: "" },
{ img: "/Storia/Il vecchio e il mare.png", title: "Il vecchio e il mare", subtitle: "" },

{ img: "/Storia/Iliade.png", title: "Iliade", subtitle: "" },

{ img: "/Storia/La divina commedia.png", title: "La divina commedia", subtitle: "" },

{ img: "/Storia/L'amore ai tempi del colera.png", title: "L'amore ai tempi del colera", subtitle: "" },
{ img: "/Storia/L'aqua di sole.png", title: "L'aqua di sole", subtitle: "" },
{ img: "/Storia/L'idiota.png", title: "L'idiota", subtitle: "" },
{ img: "/Storia/Odissea.png", title: "Odissea", subtitle: "" },
{ img: "/Storia/Se questo e un uomo.png", title: "Se questo e un uomo", subtitle: "" },
    { img: "/Storia 2/Circe.png", title: "Circo", subtitle: "" },
    { img: "/Storia 2/Commedia delle parole.png", title: "Commedia delle parole", subtitle: "" },
{ img: "/Storia 2/Delitto e Castigo.png", title: "Delitto e Castigo", subtitle: "" },

{ img: "/Storia 2/Diario.png", title: "Diario", subtitle: "" },

{ img: "/Storia 2/Favole.png", title: "Favole", subtitle: "" },

{ img: "/Storia 2/I firori del male.png", title: "I firori del male", subtitle: "" },
{ img: "/Storia 2/Il giro del mondo in 80 giorni.png", title: "Il giro del mondo in 80 giorni", subtitle: "" },
{ img: "/Storia 2/Jane Eyre.png", title: "Jane Eyre", subtitle: "" },
{ img: "/Storia 2/La canzone di Achille.png", title: "La canzone di Achille", subtitle: "" },
{ img: "/Storia 2/La scandalosa Margot.png", title: "La scandalosa Margot", subtitle: "" },


{ img: "/Storia 2/Lo sperdimento e altro.png", title: "Lo sperdimento e altro", subtitle: "" },
{ img: "/Storia 2/Ossi di seppia.png", title: "Ossi di seppia", subtitle: "" },
{ img: "/Storia 2/Poesia al senato.png", title: "Poesia al senato", subtitle: "" },

{ img: "/Storia 2/Regina di fiori.png", title: "Regina di fiori", subtitle: "" },
{ img: "/Storia 2/Si e fatto preghiera.png", title: "Si e fatto preghiera", subtitle: "" },
{ img: "/Storia 2/Tuono.png", title: "Tuono", subtitle: "" },

{ img: "/Storia 2/Appello.png", title: "Appello", subtitle: "" },

{ img: "/Storia 2/Iliade Odissea.png", title: "Iliade Odissea", subtitle: "" },

{ img: "/Storia 2/Hitler é  Buono E Vuol Bene All'italia.png", title: "Hitler é  Buono E Vuol Bene All'italia", subtitle: "" },

{ img: "/Storia 2/Rai La Grande Guerra.png", title: "Rai La Grande Guerra", subtitle: "" },


{ img: "/Storia 2/Peste e Corna.png", title: "Peste e Corna", subtitle: "" },
{ img: "/Storia 2/Il Sgnor Fiat.png", title: "Il Sgnor Fiat", subtitle: "" },

{ img: "/Storia 2/Benito Contro Mussolini.png", title: "Benito Contro Mussolini", subtitle: "" },

{ img: "/Storia 2/Dietro le quinte.png", title: "Dietro le quinte", subtitle: "" },


{ img: "/Storia 2/Questi anni nella fiat.png", title: "Questi anni nella fiat", subtitle: "" },


{ img: "/Storia 2/La grande bugia.png", title: "La grande bugia", subtitle: "" },

{ img: "/Storia 2/Diario 1939-43.png", title: "Diario 1939-43", subtitle: "" },


{ img: "/Storia 2/Lettere a Milano 1939-1945.png", title: "Lettere a Milano 1939-1945", subtitle: "" },

{ img: "/Storia 2/Caro presidente.png", title: "Caro presidente", subtitle: "" },
{ img: "/Storia 2/La lunga marcia dei Cheyenne verso l'esilio.png", title: "La lunga marcia dei Cheyenne verso l'esilio", subtitle: "" },

{ img: "/Storia 2/Aida.png", title: "Aida", subtitle: "" },    

          ]}
        />





   <Slide
          title="Libri Per Ragazzi"
          items={[
                { img: "/Libri per ragazzi/Tex.png", title: "Tex", subtitle: "1" },
    { img: "/Libri per ragazzi/Paperino.png", title: "Paperino", subtitle: "" },
{ img: "/Libri per ragazzi/Peanuts.png", title: "Peanuts", subtitle: "" },

{ img: "/Libri per ragazzi/Altan.png", title: "Altan", subtitle: "" },

{ img: "/Libri per ragazzi/KenParker.png", title: "KenParker", subtitle: "" },

{ img: "/Libri per ragazzi/Mandrake e L'uomo Maschrerato.png", title: "Mandrake e L'uomo Maschrerato", subtitle: "" },
{ img: "/Libri per ragazzi/Martin Mystere.png", title: "Martin Mystere", subtitle: "" },

{ img: "/Libri per ragazzi/Rat-Man.png", title: "Rat-Man", subtitle: "" },


{ img: "/Libri per ragazzi/Max Fridman.png", title: "Max Fridman", subtitle: "" },

{ img: "/Libri per ragazzi/Sturmtruppen.png", title: "Sturmtruppen", subtitle: "" },


{ img: "/Libri per ragazzi/Nathan Never.png", title: "Nathan Never", subtitle: "" },


{ img: "/Libri per ragazzi/Tintin.png", title: "Tintin", subtitle: "" },


{ img: "/Libri per ragazzi/Zagor.png", title: "Zagor", subtitle: "" },

{ img: "/Libri per ragazzi/Lucki Luke.png", title: "Lucki Luke", subtitle: "" },

{ img: "/Libri per ragazzi/Hulk.png", title: "Hulk", subtitle: "" },


{ img: "/Libri per ragazzi/Mafalda.png", title: "Mafalda", subtitle: "" },

{ img: "/Libri per ragazzi/Eva Kant.png", title: "Eva Kant", subtitle: "" },

{ img: "/Libri per ragazzi/Mister no.png", title: "Mister no", subtitle: "" },

{ img: "/Libri per ragazzi/Jeff Hawke.png", title: "Jeff Hawke", subtitle: "" },


{ img: "/Libri per ragazzi/Jiro.png", title: "Jiro", subtitle: "" },


{ img: "/Libri per ragazzi/Snoopy.png", title: "Snoopy", subtitle: "" },


{ img: "/Libri per ragazzi/Dilbert.png", title: "Dilbert", subtitle: "" },


{ img: "/Libri per ragazzi/Dago.png", title: "Dago", subtitle: "" },

{ img: "/Libri per ragazzi/Pogo.png", title: "Pogo", subtitle: "" },


{ img: "/Libri per ragazzi/Flash Gordon & Top Kirby.png", title: "Flash Gordon & Top Kirby", subtitle: "" },

{ img: "/Libri per ragazzi/Maus.png", title: "Maus", subtitle: "" },


{ img: "/Libri per ragazzi/Blek.png", title: "Blek", subtitle: "" },


{ img: "/Libri per ragazzi/Braccio Di Ferro.png", title: "Braccio Di Ferro", subtitle: "" },


{ img: "/Libri per ragazzi/Dick Tracy.png", title: "Dick Tracy", subtitle: "" },

{ img: "/Libri per ragazzi/Andy Capp.png", title: "Andy Capp", subtitle: "" },



{ img: "/Libri per ragazzi/Conan.png", title: "Conan", subtitle: "" },



{ img: "/Libri per ragazzi/Buzzelli.png", title: "Buzzelli", subtitle: "" },


{ img: "/Libri per ragazzi/Alack Sinner.png", title: "Alack Sinner", subtitle: "" },



{ img: "/Libri per ragazzi/Toppi.png", title: "Toppi", subtitle: "" },



{ img: "/Libri per ragazzi/Bobo.png", title: "Bobo", subtitle: "" },



          ]}
        />












<Slide
          title="Enciclopedie"
          items={[
               { img: "/Enciclopedie/A Ammorta.png", title: "A Ammorta", subtitle: "" },

 { img: "/Enciclopedie/Atello Berna.png", title: "Atello Berna", subtitle: "" },
  { img: "/Enciclopedie/Ammorti Atella.png", title: "Ammorti Atella", subtitle: "" },

{ img: "/Enciclopedie/Bernard calif.png", title: "Bernard calif", subtitle: "" },

{ img: "/Enciclopedie/Caling chies.png", title: "Caling chies", subtitle: "" },

{ img: "/Enciclopedie/Chiet costi.png", title: "Chiet costi", subtitle: "" },

{ img: "/Enciclopedie/Costo equa.png", title: "Costo equa", subtitle: "" },

{ img: "/Enciclopedie/Ecub flid.png", title: "Ecub flid", subtitle: "" },
{ img: "/Enciclopedie/Flinc golic.png", title: "Flinc golic", subtitle: "" },

{ img: "/Enciclopedie/Gllic insa.png", title: "Gllic insa", subtitle: "" },

{ img: "/Enciclopedie/Ins levic.png", title: "Ins levic", subtitle: "" },

{ img: "/Enciclopedie/Leving mossec.png", title: "Leving mossec", subtitle: "" },
{ img: "/Enciclopedie/Messia nobi.png", title: "Messia nobi", subtitle: "" },

{ img: "/Enciclopedie/Nobo pella.png", title: "Nobo pella", subtitle: "" },
{ img: "/Enciclopedie/Pelle produt.png", title: "Pelle produt", subtitle: "" },

{ img: "/Enciclopedie/Produz robd.png", title: "Produz robd", subtitle: "" },
{ img: "/Enciclopedie/Rode serbia.png", title: "Rode serbia", subtitle: "" },

{ img: "/Enciclopedie/Serbo strus.png", title: "Serbo strus", subtitle: "" },

{ img: "/Enciclopedie/Strut tuot.png", title: "Strut tuot", subtitle: "" },

{ img: "/Enciclopedie/Tup z.png", title: "Tup zt", subtitle: "" },



]}
        />


















<Slide
          title="Altro"
          items={[
               { img: "/Altro/Agalma.png", title: "Agalma", subtitle: "" },
    { img: "/Altro/Altrer ego 2.png", title: "Altrer ego 2", subtitle: "" },
{ img: "/Altro/Altrer ego.png", title: "Altrer ego", subtitle: "" },

{ img: "/Altro/Architettura del simbolo.png", title: "Architettura del simbolo", subtitle: "" },

{ img: "/Altro/Bell'italia.png", title: "Bell'italia", subtitle: "" },

{ img: "/Altro/Corpi e materie.png", title: "Corpi e materie", subtitle: "" },
{ img: "/Altro/Corpi motivi.png", title: "Corpi motivi", subtitle: "" },
{ img: "/Altro/Dammi mille.png", title: "Dammi mille", subtitle: "" },
{ img: "/Altro/Disegni.png", title: "Disegni", subtitle: "" },
{ img: "/Altro/Domenico fategati.png", title: "Domenico fategati", subtitle: "" },
    { img: "/Altro/Filiere in sinergia.png", title: "Filiere in sinergia", subtitle: "" },
    { img: "/Altro/Gardenia 2.png", title: "Gardenia 2", subtitle: "" },
{ img: "/Altro/Gardenia.png", title: "Gardenia", subtitle: "" },

{ img: "/Altro/Gerdenia 3.png", title: "Gerdenia 3", subtitle: "" },

{ img: "/Altro/Marcovaldo.png", title: "Marcovaldo", subtitle: "" },

{ img: "/Altro/Pantelleria 2.png", title: "Pantelleria 2", subtitle: "" },
{ img: "/Altro/Pantelleria.png", title: "Pantelleria", subtitle: "" },
{ img: "/Altro/Rapporto annuale 2018.png", title: "Rapporto annuale 2018", subtitle: "" },
{ img: "/Altro/Sculture e disegni.png", title: "Sculture e disegni", subtitle: "" },
{ img: "/Altro/Tesori dell'arte 2.png", title: "Tesori dell'arte 2", subtitle: "" },


{ img: "/Altro/Tesori dell'arte.png", title: "Tesori dell'arte", subtitle: "" },
{ img: "/Altro/Tips del naples 2.png", title: "Tips del naples 2", subtitle: "" },
{ img: "/Altro/tips del naples 3.png", title: "tips del naples 3", subtitle: "" },

{ img: "/Altro/Tips del naples.png", title: "Tips del naples", subtitle: "" },
{ img: "/Altro/Triiade.png", title: "Triiade", subtitle: "" },
{ img: "/Altro/Ulodea.png", title: "Ulodea", subtitle: "" },


{ img: "/Altro/Uomini e culture della sicilia prestorica.png", title: "Uomini e culture della sicilia prestorica", subtitle: "" },
{ img: "/Altro/Va dove ti porta il cuore.png", title: "Va dove ti porta il cuore", subtitle: "" },
{ img: "/Altro/Vesuvio.png", title: "Vesuvio", subtitle: "" },

{ img: "/Altro/Vitenologia in campania.png", title: "Vitenologia in campania", subtitle: "" },

{ img: "/Altro/La verità sugli scandali finanziari.png", title: "La verità sugli scandali finanziari", subtitle: "" },

{ img: "/Altro/La Fiera delle castronerie.png", title: "La Fiera delle castronerie", subtitle: "" },

{ img: "/Altro/Introduzione alla psicologia sociale.png", title: "Introduzione alla psicologia sociale", subtitle: "" },

{ img: "/Altro/Il diziionario della medicina.png", title: "Il diziionario della medicina", subtitle: "" },







]}
        />



      </div>
    </>
  );
}








































